import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '../../../core/services/api.service';
import { LocalService } from '../../../core/services/local.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { UpperCaseDirective } from '../../../shared/directives/upper-case.directive';
import { MatInputModule } from '@angular/material/input';

const materialModules = [
  MatIconModule,
  MatDialogModule,
  MatButtonModule,
  MatFormFieldModule,
  MatInputModule,
  ReactiveFormsModule
]

const directives = [
  UpperCaseDirective
]

@Component({
  selector: 'app-lockers-access',
  standalone: true,
  imports: [TranslateModule, ...materialModules, ...directives],
  templateUrl: './locker-access.component.html',
  styleUrls: ['./locker-access.component.scss']
})
export class LockerAccessComponent implements OnInit {

  validLogin: boolean = false;

  form = new FormGroup({
    code: new FormControl('',
      [Validators.required, Validators.minLength(5), Validators.maxLength(5)]
    ),
  });

  constructor(
    private api: ApiService,
    private local: LocalService,
    private dialogRef: MatDialogRef<LockerAccessComponent>
  ) { }

  ngOnInit(): void {}

  login() {
    const form = this.form.getRawValue();

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.api.getLockersClient(form.code!).subscribe(data => {
      if (data.success) {
        this.local.saveData('lockerUser', JSON.stringify(data.client));
        this.validLogin = true;
        this.close();
      }
    });
  }

  close() {
    this.dialogRef.close(this.validLogin);
  }
}
